
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface RecipeUrlInputInlineProps {
  url: string;
  setUrl: (url: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
}

const RecipeUrlInputInline = ({ url, setUrl, onSubmit, isLoading }: RecipeUrlInputInlineProps) => {
  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <div className="space-y-2">
        <Input
          type="url"
          placeholder="Paste recipe website URL here"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={isLoading}
          className="text-sm"
        />
      </div>
      <Button 
        type="submit" 
        className="w-full bg-recipe hover:bg-recipe-dark text-recipe-foreground text-sm" 
        disabled={isLoading}
        size="sm"
      >
        {isLoading ? (
          <span className="flex items-center">
            <Loader2 className="mr-2 h-3 w-3 animate-spin" />
            Processing...
          </span>
        ) : "Extract Recipe with AI"}
      </Button>
    </form>
  );
};

export default RecipeUrlInputInline;
